import React, { FC, useEffect, useState } from "react";
import { ScheduleData } from "../../interface/schedule";

import { Box, Button, Stack, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import { useTheme } from "@mui/material/styles";
import { btnSty } from "../ui-styles";
import ScheduleInformation from "./scheduleInformation";
import { ShiftTypeModal } from "./ScheduleModal";
import { useMutation } from "@tanstack/react-query";
import { apiGetEmploymentsByFacility } from "../../api/employment";
import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../notification";
import { EmploymentDetailsProps } from "../../interface/employment";
import { AddCircleOutlined, DeleteOutline, PlusOne } from "@mui/icons-material";
import { apiDeleteShedule } from "../../api/schedules";
import { LoadingButton } from "@mui/lab";

const ScheduleDetailsInfo: FC<{
  scheduleInfo: any;
  mode: string;
  closeModal: () => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ mode, scheduleInfo, setRefresh, closeModal }) => {
  const isSmall = useResponsive("down", "sm", "xl");
  const { showNotification } = useNotificationService();
  const [employment_list, setEmployment_list] = useState<
    EmploymentDetailsProps[]
  >([]);

  const [openShift, setOpenShift] = useState(false);

  const handleShiftType = () => {
    setOpenShift(!openShift);
  };
  useEffect(() => {
    mutation.mutate();
  }, []);
  const mutation = useMutation({
    mutationFn: () => apiGetEmploymentsByFacility("", ""),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        if (data?.data?.data?.length > 0) {
          setEmployment_list(data.data.data);
        } else {
          setEmployment_list([]);
        }
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });
  const deleteMutation = useMutation({
    mutationFn: apiDeleteShedule,
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        setRefresh((prev) => !prev);
        closeModal();
      }
    },
    onError: (error) => {
      console.error("Process failed", error);
      // Handle error
      showNotification("Process failed", "error");
    },
  });
  const handleDelete = () => {
    const values = { schedule_id: scheduleInfo?._id };
    deleteMutation.mutate(values);
  };

  return (
    <Box sx={{ padding: 3 }}>
      <ShiftTypeModal
        setRefresh={setRefresh}
        open={openShift}
        closeModal={closeModal}
        handleModal={handleShiftType}
        scheduleId={scheduleInfo._id}
        employeeList={employment_list}
        loading={mutation.isPending}
        start={scheduleInfo?.start}
        end={scheduleInfo?.end}
      />

      {/* <AppriasalSchedule /> */}
      <Stack
        direction={isSmall ? "column" : "row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{ paddingX: 2, mt: 3 }}
      >
        <Typography
          variant="subtitle2"
          color={"neutral"}
          sx={{ fontWeight: 700, fontFamily: "Inter" }}
        >
          Schedule Information
        </Typography>
        <Stack
          direction={isSmall ? "column" : "row"}
          sx={{ gap: isSmall ? 2 : 4, my: 2 }}
        >
          <LoadingButton
            loading={deleteMutation.isPending}
            onClick={handleDelete}
            color="error"
            variant="contained"
          >
            <DeleteOutline />
            Delete Schedule
          </LoadingButton>
          <Button
            onClick={handleShiftType}
            variant="contained"
            sx={{
              color: "white",
            }}
          >
            <AddCircleOutlined />
            Create New Shift Type
          </Button>
        </Stack>
      </Stack>

      <ScheduleInformation
        mode={mode}
        scheduleInfo={scheduleInfo}
        setRefresh={setRefresh}
        closeModal={closeModal}
      />
    </Box>
  );
};

export default ScheduleDetailsInfo;
